if ($(".chat-application").length) {
    (function ($) {
        let conversationId;

        const imagePreview = document.querySelector(".image-preview");
        const imageModal = document.getElementById("imageModal");
        const fileInput = document.getElementById("chat-image-file-input");

        if (imagePreview) {
            fileInput.onchange = () => {
                if (fileInput.files.length) {
                    try {
                        if (/\.(jpe?g|png)$/i.test(fileInput.files[0].name) === false || fileInput.files[0].type.match(
                            'image.*') === null) {
                            throw new Error('Lütfen geçerli bir resim dosyası seçiniz. JPG veya PNG')
                        }

                        const imageUrl = window.URL.createObjectURL(
                            fileInput.files[0]
                        );
                        imageModal.querySelector("img").src = imageUrl;
                        $("#imageModal").modal("show");
                    } catch (e) {
                        toastr.error(e.message)
                    }
                }
            }
        }

        const receiverId = $(".chat-application").data("selected-receiver");
        if (receiverId) {
            setTimeout(function () {
                $(document)
                    .find(`[data-receiver-id="${receiverId}"]`)
                    .trigger("click");
            }, 30);
        }

        // Scroll to bottom function
        function scrollToBottom() {
            setTimeout(() => {
                $(".user-chats").scrollTop(
                    $(".user-chats > .chats").height()
                );
            }, 200)
        }

        // Leave channel
        function leaveChannels(contains) {
            Object.entries(window.Echo.connector.channels).forEach(function (
                channel
            ) {
                if (channel.includes(contains)) {
                    window.Echo.leaveChannel(channel);
                }
            });
        }

        function conversationListen(id) {
            leaveChannels("conversation");
            window.Echo.private(`conversation.${id}`).listen(
                ".receiver",
                (response) => {
                    response.is_sender = false;

                    const view = {
                        items: response,
                    };

                    const compile = Handlebars.compile(
                        $("#text-message-template").html()
                    );
                    const template = compile(view);

                    $(".user-chats > .chats").append(template);
                    scrollToBottom();
                }
            );
        }

        $("#giveAccess").on("show.bs.modal", function () {
            const activeChat = $(".chat-users-list-wrapper li.active");
            const url = activeChat.data("give-url");
            $(this).find(".modal-title").text(activeChat.data("name"));
            $(this)
                .find("input[name=conversation_id]")
                .val(activeChat.data("conversation-id"));
            $(this).find("form").attr("action", url);
        });

        $("#giveAccess form").submit(function (e) {
            e.preventDefault();
            $.ajax({
                url: $(this).attr("action"),
                type: "POST",
                dataType: "json",
                data: $(this).serialize(),
                success(response) {
                    if (response.status) {
                        const activeChat = $(".active-chat");
                        activeChat
                            .find(".access-list")
                            .removeClass("d-none")
                            .addClass("d-flex");
                        activeChat
                            .find(".give-access")
                            .removeClass("d-flex")
                            .addClass("d-none");
                        $("#giveAccess").modal("hide");
                        toastr.success(response.message);
                    } else {
                        toastr.error(response.message);
                    }
                },
                error(error) {
                    // TODO
                },
            });
        });

        // Chat user list
        if ($(".chat-application .chat-user-list").length > 0) {
            new PerfectScrollbar(".chat-user-list");
        }

        // Chat user profile
        if (
            $(".chat-application .profile-sidebar-area .scroll-area").length > 0
        ) {
            new PerfectScrollbar(".profile-sidebar-area .scroll-area");
        }

        // Chat Profile sidebar toggle
        $(".chat-application .sidebar-profile-toggle").on("click", function () {
            $(".chat-profile-sidebar").addClass("show");
            $(".chat-overlay").addClass("show");
        });

        // User Profile sidebar toggle
        $(".chat-application .user-profile-toggle").on("click", function (e) {
            e.preventDefault();
            const activeChat = $(".chat-users-list-wrapper li.active");
            const url = activeChat.data("receiver-url");
            $.ajax({
                url,
                type: "POST",
                dataType: "json",
                success(response) {
                    const view = {
                        item: response.data,
                    };
                    const html = Mustache.render(
                        $("#contact-detail").html(),
                        view
                    );

                    $(".user-profile-sidebar").addClass("show");
                    $(".chat-overlay").addClass("show");
                    $(".user-profile-sidebar .detail").html(html);

                    if (
                        $(".chat-application .user-profile-sidebar-area")
                            .length > 0
                    ) {
                        new PerfectScrollbar(".user-profile-sidebar-area");
                    }
                },
                error(error) {
                    // TODO
                },
            });
        });

        // On Profile close click
        $(".chat-application .close-icon").on("click", function () {
            $(".chat-profile-sidebar").removeClass("show");
            $(".user-profile-sidebar").removeClass("show");
            if (!$(".sidebar-content").hasClass("show")) {
                $(".chat-overlay").removeClass("show");
            }
        });

        // On sidebar close click
        $(".chat-application .sidebar-close-icon").on("click", function () {
            $(".sidebar-content").removeClass("show");
            $(".chat-overlay").removeClass("show");
        });

        // On overlay click
        $(".chat-application .chat-overlay").on("click", function () {
            $(".app-content .sidebar-content").removeClass("show");
            $(".chat-application .chat-overlay").removeClass("show");
            $(".chat-profile-sidebar").removeClass("show");
            $(".user-profile-sidebar").removeClass("show");
        });

        // Add class active on click of Chat users list
        $(".chat-application .chat-user-list ul li").on("click", function () {
            if ($(".chat-user-list ul li").hasClass("active")) {
                $(".chat-user-list ul li").removeClass("active");
            }

            $(this).addClass("active");

            $(this).find(".badge").remove();
        });

        function setUserInfo() {
            const $this = $('.chat-application .chat-user-list ul li.active');
            if ($this) {
                const name = $this.data("name");
                const avatar = $this.data("avatar");
                const startChat = $(".start-chat-area");
                const activeChat = $(".active-chat");
                startChat.removeClass("d-none");
                activeChat.removeClass("d-none");
                activeChat.find(".username").text(name);
                activeChat
                    .find(".user-profile-toggle")
                    .attr("data-receiver-id", $this.data("receiver-id"));

                if ($this.data("is-partner")) {

                    if ($this.data("has")) {
                        activeChat
                            .find(".access-list")
                            .removeClass("d-none")
                            .addClass("d-flex");
                        activeChat
                            .find(".give-access")
                            .removeClass("d-flex")
                            .addClass("d-none");
                    } else {
                        activeChat
                            .find(".access-list")
                            .removeClass("d-flex")
                            .addClass("d-none");
                        activeChat
                            .find(".give-access")
                            .removeClass("d-none")
                            .addClass("d-flex");
                    }
                }

                if (avatar) {
                    activeChat.find(".user-avatar")
                        .html(`<img src="${avatar}" class="user-avatar" alt="" height="40" width="40">`);
                } else {
                    activeChat.find(".user-avatar")
                        .html(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512" width="40" height="40">
                            <path fill="currentColor"
                            d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0 88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4 55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1 7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z">
                            </path>
                        </svg>`);
                }
            } else {
                activeChat.addClass("d-none");
            }
        }

        // autoscroll to bottom of Chat area
        const chatContainer = $(".user-chats");
        $(".chat-users-list-wrapper li").click(function (e) {
            e.preventDefault();
            conversationId = $(this).data("conversation-id");
            const url = $(".chat-application").data("message-url");
            if (conversationId) {
                conversationListen(conversationId);
                $.ajax({
                    url: url,
                    type: "POST",
                    dataType: "json",
                    data: {
                        conversation_id: Number(conversationId),
                    },
                    beforeSend() {
                        $(".start-chat-area").html(
                            '<span class="start-chat-icon chat-loading feather icon-loader mb-1"></span><h4 class="py-50 sidebar-toggle start-chat-text px-1">Sohbetler yükleniyor...</h4>'
                        );
                    },
                    success(response) {
                        const view = {
                            items: response.data,
                        };

                        const compile = Handlebars.compile(
                            $("#active-chat").html()
                        );
                        const template = compile(view);

                        chatContainer.html(template);

                        if ($(".chat-application .user-chats").length > 0) {
                            new PerfectScrollbar(".user-chats", {
                                wheelPropagation: false,
                            });
                        }

                        $("input.message").focus();

                        setUserInfo();
                        scrollToBottom();
                        $(".start-chat-area").addClass("d-none");
                        $(".chat-app-form").removeClass("d-none");
                        $(".sidebar-content").removeClass("show")
                    },
                    error(error) {
                        $(".start-chat-area").html(
                            '<span class="start-chat-icon feather icon-x mb-1"></span><h4 class="py-50 sidebar-toggle start-chat-text px-1">Sohbetler yüklenemedi!</h4>'
                        );
                    }
                });
            }
        });

        // Main menu toggle should hide app menu
        $(".chat-application .menu-toggle").on("click", function (e) {
            $(".app-content .sidebar-left").removeClass("show");
            $(".chat-application .chat-overlay").removeClass("show");
        });

        // Chat sidebar toggle
        if ($(window).width() < 992) {
            $(".chat-application .sidebar-toggle").on("click", function () {
                $(".app-content .sidebar-content").addClass("show");
                $(".chat-application .chat-overlay").addClass("show");
            });
        }

        // For chat sidebar on small screen
        if ($(window).width() > 992) {
            if ($(".chat-application .chat-overlay").hasClass("show")) {
                $(".chat-application .chat-overlay").removeClass("show");
            }
        }

        // Scroll Chat area
        scrollToBottom();

        // Filter
        $(".chat-application #chat-search").on("keyup", function () {
            const value = $(this).val().toLowerCase();
            if (value !== "") {
                $(".chat-user-list .chat-users-list-wrapper li").filter(() =>
                    $(this).toggle(
                        $(this).text().toLowerCase().indexOf(value) > -1
                    )
                );
            } else {
                // If filter box is empty
                $(".chat-user-list .chat-users-list-wrapper li").show();
            }
        });
    })(jQuery);

    $(window).on("resize", function () {
        // remove show classes from sidebar and overlay if size is > 992
        if ($(window).width() > 992) {
            if ($(".chat-application .chat-overlay").hasClass("show")) {
                $(".app-content .sidebar-left").removeClass("show");
                $(".chat-application .chat-overlay").removeClass("show");
            }
        }

        // Chat sidebar toggle
        if ($(window).width() < 992) {
            if ($(".chat-application .chat-profile-sidebar").hasClass("show")) {
                $(".chat-profile-sidebar").removeClass("show");
            }
            $(".chat-application .sidebar-toggle").on("click", function () {
                $(".app-content .sidebar-content").addClass("show");
                $(".chat-application .chat-overlay").addClass("show");
            });
        }
    });

    function messageCreate(data) {
        const url = $(".chat-application").data("create-url");
        $.ajax({
            url: url,
            type: "POST",
            contentType: false,
            processData: false,
            data,
        });
    }

    function sendMessage() {
        const message = $(".message").val();
        const activeChat = $(".chat-application .chat-user-list ul li.active");
        conversationId = activeChat.data("conversation-id");
        let avatar = $(".chat-application").data("current-avatar");

        if (message !== "" || !conversationId) {
            const view = {
                items: {
                    sender: {
                        avatar: {
                            url: avatar,
                        },
                    },
                    message: message,
                    time: "şimdi",
                    is_read: false,
                    type: 0,
                    is_sender: true,
                },
            };

            const compile = Handlebars.compile(
                $("#text-message-template").html()
            );
            const template = compile(view);

            $(".user-chats > .chats").append(template);

            const data = new FormData();
            data.append("conversation_id", conversationId);
            data.append("message", message);

            messageCreate(data);

            $(".message").val("");

            $(".user-chats").scrollTop($(".user-chats > .chats").height());
        }
    }

    function sendImage() {
        const data = new FormData();
        const activeChat = $(".chat-application .chat-user-list ul li.active");
        conversationId = activeChat.data("conversation-id");
        let avatar = $(".chat-application").data("current-avatar");
        const inputFile = document.getElementById("chat-image-file-input");
        const imageUrl = window.URL.createObjectURL(inputFile.files[0]);
        data.append("conversation_id", conversationId);
        data.append("type", 1);
        data.append("file", inputFile.files[0]);
        if (conversationId) {
            const view = {
                items: {
                    sender: {
                        avatar: {
                            url: avatar,
                        },
                    },
                    image: {
                        url: imageUrl,
                    },
                    time: "şimdi",
                    is_read: false,
                    is_sender: true,
                    type: 1,
                },
            };

            const compile = Handlebars.compile(
                $("#text-message-template").html()
            );
            const template = compile(view);

            $(".user-chats > .chats").append(template);
            messageCreate(data);
            $("#imageModal").modal("hide");
            scrollToBottom();
        }
    }
}
